module.exports = __webpack_public_path__ + "img/slemmestad.611a8102.jpeg";